import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/contant';
import { motion } from 'framer-motion';
import Navbar from './Navbar';

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
      ease: 'easeOut',
    },
  }),
};

const pageVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const ServiceCard = ({ id, image, title, link, index }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(link);
  };

  return (
    <motion.div
      custom={index}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      className="w-full md:w-1/3 p-4 cursor-pointer"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <div className="bg-white shadow-lg rounded overflow-hidden flex flex-col transform hover:scale-105 transition-transform duration-300">
        <div
          className="block h-60 bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
          aria-label={`View details for ${title}`}
        ></div>
        <div className="p-4 flex flex-col">
          <h3 className="text-lg font-semibold mb-2 hover:underline">{title}</h3>
        </div>
      </div>
    </motion.div>
  );
};

ServiceCard.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  link: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const Service = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 9;

  const totalPosts = blogPosts.length;
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const currentPosts = blogPosts.slice(startIndex, startIndex + postsPerPage);

  return (
    <>
      <Navbar />
      <motion.section
        className="py-16 bg-gray-100"
        initial="hidden"
        animate="visible"
        variants={pageVariant}
      >
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Services</h2>
          <div className="flex flex-wrap -mx-4">
            {currentPosts.map((post, index) => (
              <ServiceCard key={post.id} {...post} index={index} />
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex justify-center mt-8 space-x-2">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => {
                    setCurrentPage(index + 1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`px-4 py-2 rounded ${
                    currentPage === index + 1
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                  aria-label={`Go to page ${index + 1}`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </motion.section>
    </>
  );
};

export default Service;
